import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { OtherHealthProfessionals, SpecialistsType } from '../../../../types';

const SpecialistsInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      <h3>Specialists</h3>
      {selectedClient?.specialists?.length ?
        selectedClient?.specialists?.map((specialist: SpecialistsType) => (
          <>
            <FormInfoWrapper>
              <div>For what?</div>
              <div>{specialist?.forWhat}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Since when?</div>
              <div>{specialist?.sinceWhen}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Name</div>
              <div>{specialist?.name}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Address</div>
              <div>{specialist?.address}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Telephone country code</div>
              <div>{specialist?.telephoneCountryCode}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Telephone number</div>
              <div>{specialist?.telephoneNumber}</div>
            </FormInfoWrapper>
          </>
        )) :
        <span>None</span>
      }
      <h3>Other health professionals</h3>
      {selectedClient?.otherHealthProfessionals?.length ?
        selectedClient?.otherHealthProfessionals?.map((specialist: OtherHealthProfessionals, index: number) => (
          <>
            <p>{`${++index})`}</p>
            <FormInfoWrapper>
              <div>For what?</div>
              <div>{specialist?.forWhat}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Since when?</div>
              <div>{specialist?.sinceWhen}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Name</div>
              <div>{specialist?.name}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Address</div>
              <div>{specialist?.address}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Telephone country code</div>
              <div>{specialist?.telephoneCountryCode}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>Telephone number</div>
              <div>{specialist?.telephoneNumber}</div>
            </FormInfoWrapper>
          </>
        )) :
        <span>None</span>
      }
    </Container>
  )
}

export default SpecialistsInfo
